import { render, staticRenderFns } from "./BatchRecommendations.vue?vue&type=template&id=12b3bebb&scoped=true&"
import script from "./BatchRecommendations.vue?vue&type=script&lang=js&"
export * from "./BatchRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./BatchRecommendations.vue?vue&type=style&index=0&id=12b3bebb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3bebb",
  null
  
)

export default component.exports